import {Vue} from '~/addiesaas'
import * as types from '../mutation-types/pages'
const EventBus = window.VueEventBus

// set this true to namespace all getters, mutations, actions etc.
const namespaced =  true
export const namespace = 'pages'

const timeOutDisableBillingButton = 5*60*1000

const helpers = {
  getTimeOutDisableBillingButton(state) {
    const time = (new Date()).getTime()
    const deltaTime = time - state.expirationTimeBillingError
    if (deltaTime < timeOutDisableBillingButton) {
      return timeOutDisableBillingButton - deltaTime
    } else {
      return 0
    }
  }
}

// state
const state = {
  postLoginPage: 'page-profile',
  postLoginSection: null,
  postLoginSubSection: null,
  isPreCheckoutRegistration: false,
  checkoutState: 'cart',
  showingResetPassword: false,
  userVerificationPrompt: false,
  showGlobalTimer: true,
  alertOnTimeoutShown: false,
  showGeneralAlertPopup: false,
  timeoutRemovedTypes: {},
  getTimeoutRemovedItems: () => {},
  billingTotal: false,
  billingGuestEmail: false,
  expirationTimeBillingError: false,
}

// mutations
const mutations = {
  [types.SET_POST_LOGIN_PAGE](state, page) {
    state.postLoginPage = page
  },
  [types.SET_POST_LOGIN_SECTION](state, page) {
    const parts = (page || '').split('#')
    state.postLoginSection = parts[0] || null
    state.postLoginSubSection = parts[1] || null
  },
  [types.SET_PRE_CHECKOUT_REGISTRATION](state, yn) {
    state.isPreCheckoutRegistration = yn
  },

  [types.SET_CHECKOUT_STATE](state, stateType) {
    state.checkoutState = stateType
  },
  [types.SHOW_RESET_PASSWORD](state, show) {
    state.showingResetPassword = show === undefined ? true : show
  },
  [types.SHOW_USER_VERIFICATION_PROMPT](state, show) {
    state.userVerificationPrompt = show === undefined ? true : show
  },
  [types.SHOW_GENERAL_ALERT_POPUP](state, show) {
    state.showGeneralAlertPopup = show === undefined ? true : show
  },
  [types.HIDE_GLOBAL_TIMER](state, hide) {
    state.showGlobalTimer = hide === false
  },
  [types.SHOW_ITEM_REMOVED_ON_TIMEOUT_ALERT](state, show) {
    state.alertOnTimeoutShown = show !== false
  },
  [types.SET_ITEM_TYPE_REMOVED_ON_TIMEOUT](state, itemTypes) {
    if (_.isString(itemTypes)) {
      itemTypes = [itemTypes]
    }
    _.forOwn(itemTypes, itemType => {
      Vue.set(state.timeoutRemovedTypes, itemType, true)
    })
  },
  [types.SET_ITEM_REMOVED_ON_TIMEOUT](state, item) {
    const fn = state.getTimeoutRemovedItems
    fn.items = fn.items || []
    fn.items.push(item)
    state.getTimeoutRemovedItems = () => {
      return fn.items
    }
  },
  [types.UNSET_ITEM_REMOVED_ON_TIMEOUT](state, item) {
    const fn = state.getTimeoutRemovedItems
    fn.items = fn.items || []
    fn.items = fn.items.filter(i => i._uid === item._uid)
    state.getTimeoutRemovedItems = () => {
      return fn.items
    }
  },
  [types.SET_EXPIRATION_TIME_BILLING_ERROR](state, time) {
    state.expirationTimeBillingError = time
  },
  [types.SET_BILLING_TOTAL](state, total) {
    state.billingTotal = total
  },
  [types.SET_BILLING_GUEST_EMAIL](state, email) {
    state.billingGuestEmail = email
  },
}

const actions = {
  setPostLoginPage ({ commit }, payload) {
    commit(types.SET_POST_LOGIN_PAGE, payload)
  },
  setPostLoginSection ({ commit }, payload) {
    commit(types.SET_POST_LOGIN_SECTION, payload)
  },
  setIsPreCheckoutRegistration ({ commit }, yn) {
    commit(types.SET_PRE_CHECKOUT_REGISTRATION, yn)
  },
  setCheckoutState({commit, state}, stateType) {
    commit(types.SET_CHECKOUT_STATE, stateType)
  },
  showResetPassword({commit, state}, show) {
    commit(types.SHOW_RESET_PASSWORD, show)
  },
  showUserVerificationPrompt({commit, state}, show) {
    commit(types.SHOW_USER_VERIFICATION_PROMPT, show)
  },
  hideGlobalTimer({commit, state}, hide) {
    commit(types.HIDE_GLOBAL_TIMER, hide)
  },
  showTimeoutAlert({commit, state}, show) {
    commit(types.SHOW_ITEM_REMOVED_ON_TIMEOUT_ALERT, show)
  },
  showGeneralAlertPopup({commit, state}, show) {
    commit(types.SHOW_GENERAL_ALERT_POPUP, show)
  },
  setTimeoutRemovedTypes({commit, state}, itemTypes) {
    commit(types.SET_ITEM_TYPE_REMOVED_ON_TIMEOUT, itemTypes)
  },
  setTimeoutRemovedItem({commit, state}, item) {
    commit(types.SET_ITEM_REMOVED_ON_TIMEOUT, item)
  },
  unsetTimeoutRemovedItem({commit, state}, item) {
    commit(types.UNSET_ITEM_REMOVED_ON_TIMEOUT, item)
  },
  setExpirationTimeBillingError({commit}, time) {
    commit(types.SET_EXPIRATION_TIME_BILLING_ERROR, time)
  },
  setBillingTotal({commit}, total) {
    commit(types.SET_BILLING_TOTAL, total)
  },
  setBillingGuestEmail({commit}, email) {
    commit(types.SET_BILLING_GUEST_EMAIL, email)
  }
}

// getters
const getters = {
  loginRedirect: state => state.postLoginPage,
  loginRedirectSection: state => state.postLoginSection,
  loginRedirectSubSection: state => state.postLoginSubSection,
  userVerificationPrompt: state => state.userVerificationPrompt,
  isPreCheckoutRegistration: state => state.isPreCheckoutRegistration,
  checkoutState: state => state.checkoutState,
  resettingPassword: state => state.showingResetPassword,
  showingGlobalTimer: state => state.showGlobalTimer,
  isAlertOnTimeoutShown: state => state.alertOnTimeoutShown,
  isGeneralAlertPopupShown: state => state.showGeneralAlertPopup,
  timeoutRemovedTypes: state => _.keys(state.timeoutRemovedTypes|| {}),
  getTimeoutRemovedItems: state => state.getTimeoutRemovedItems,
  isBillingError: state => state.expirationTimeBillingError && helpers.getTimeOutDisableBillingButton(state) > 0,
  expirationTime: state => state.expirationTimeBillingError,
  timeOutDisableBillingButton: state => state.expirationTimeBillingError ? helpers.getTimeOutDisableBillingButton(state) : timeOutDisableBillingButton,
  billingTotal: state => state.billingTotal,
  billingGuestEmail: state => state.billingGuestEmail
}

const pages =  { namespaced, namespace, state, mutations, actions, getters }
export default pages
